import React, { useState } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

const DeviceDialog = (props) => {
  const [uuid, setUuid] = useState(props.UUID || '');
  const [name, setName] = useState(props.Tenant || '');
  const [publicKey, setPublicKey] = useState(props.public_key || '');
  const [confirmTxt, setConfirmTxt] = useState('');

  const actionByType = () => {
    if (props.type === 'create') {
      return (
        <Button variant='contained' color='primary' disabled={!uuid} autoFocus
          onClick={() => props.handleOk(uuid, name, publicKey)}
        >Create Tenant Device Map
        </Button>
      );
    } else if (props.type === 'edit') {
      return (
        <Button variant='contained' color='primary'
          disabled={!name} autoFocus
          onClick={() => props.handleOk({ Tenant: name, public_key: publicKey })}
        >Save changes</Button>
      );
    } else if (props.type === 'unlink') {
      return (
        <Button variant='contained' color='primary'
          onClick={() => props.handleOk()}
        >Unlink Device</Button>
      );
    } else if (props.type === 'delete') {
      return (
        <Button variant='contained' color='primary' autoFocus onClick={() => props.handleOk()} disabled={confirmTxt !== 'yes'}>
          Delete
        </Button>
      );
    } else if (props.type === 'setpublickey') {
      return (
        <Button variant='contained' color='primary' autoFocus disabled={props.public_key === publicKey}
          onClick={() => props.handleOk({ Tenant: name, public_key: publicKey })}
        >
          Save Changes
        </Button>        
      );
    }
  };
  const titleByType = () => {
    if (props.type === 'create') {
      return 'Create Tenant Device Map';
    } else if (props.type === 'edit') {
      return 'Change Tenant';
    }else if (props.type === 'unlink') {
      return 'Unlink Device';
    } else if (props.type === 'publickey') {
      return 'Public Key';
    } else if (props.type === 'delete') {
      return 'Delete Device';
    } else if (props.type === 'setpublickey') {
      return 'Change Public Key';
    } else {
      return 'Invalid Dialog Type';
    }
  };
  const contentByType = () => {
    if (props.type === 'create') {
      return (
        <>
          <TextField label='UUID' value={uuid}
            onChange={e => setUuid(e.target.value)}
            fullWidth required
            disabled={props.type !== 'create'}
          />
          <TextField label='Tenant' value={name}
            onChange={e => setName(e.target.value)}
            select fullWidth required={props.type === 'edit'}
          >
            {
              props.tenantList.map((item, idx) => {
                return (
                  <MenuItem key={idx} value={item.name}>{item.name}</MenuItem>
                );
              })
            }
          </TextField>
          <TextField label='Public key' value={publicKey}
            onChange={e => setPublicKey(e.target.value)}
            fullWidth
          />
        </>
      );
    } else if (props.type === 'edit') {
      return (
        <>
          <Typography color='primary'> {`Choose a tenant which will be assign to the selected ${pluralize('device', props.selCount)}`}</Typography>
          <TextField label='Tenant' value={name}
            onChange={e => setName(e.target.value)}
            select fullWidth required={props.type === 'edit'}
          >
            {
              props.tenantList.map((item, idx) => {
                return (
                  <MenuItem key={idx} value={item.name}>{item.name}</MenuItem>
                );
              })
            }
          </TextField>
        </>
      );
    }else if (props.type === 'setpublickey') {
      return (
        <>
          <TextField label='UUID' value={uuid}
            onChange={e => setUuid(e.target.value)}
            fullWidth required
            disabled={true}
          />
          <TextField label='Public key' value={publicKey}
            onChange={e => setPublicKey(e.target.value)}
            fullWidth
          />
        </>
      );
    } else if (props.type === 'unlink') {
      return (
        <Typography color='primary'> {`The selected ${pluralize('device', props.selCount)} will be decommissioned from the tenant!`}</Typography>
      );
    } else if(props.type === 'publickey') {
      return (
        <Typography>{publicKey || 'Not Assigned'}</Typography>
      );
    } else if (props.type === 'delete') {
      return (
        <>
          <Typography>{`Are you sure want to delete selected ${pluralize('device', props.selCount)}`}</Typography>
          <Typography color='primary'>{`All Data related to the selected ${pluralize('device', props.selCount)} will be permanently deleted. Confirm by typing the "yes" in the box below`}</Typography>
          <TextField label='yes' value={confirmTxt}
            onChange={e => setConfirmTxt(e.target.value)}
            fullWidth required
          />
        </>
      );
    }
  };
  return (
    <Dialog
      open={true}
      maxWidth={props.type === 'publickey' && publicKey ? 'md' : 'xs'}
      fullWidth
    >
      <DialogTitle>{titleByType()}</DialogTitle>
      <DialogContent>
        {contentByType()}
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={props.handleCancel}>Cancel</Button>
        {actionByType()}
      </DialogActions>
    </Dialog>
  );
};

DeviceDialog.propTypes = {
  UUID: PropTypes.bool,
  publicKey: PropTypes.string,
  type: PropTypes.string,
  tenantList: PropTypes.array,
  handleOk: PropTypes.func,
  handleCancel: PropTypes.func,
  selCount: PropTypes.number
};

export default DeviceDialog;
